<template>
  <section>
    <Title :title-name="title.FlyToDay.titleName" :title-link="title.FlyToDay.titleLink" />
    <div class="ServiceRefreshment">
      <div class="container" style="margin-top: 14pt">
        <p>Dear {{ pax.title }} {{ pax.first_name }} {{ pax.last_name }} ,</p>
        <div>
          <p>
            We have rebooked you to flight <span v-if="Rebook">{{ Rebook.fight_number }}</span> from
            <span v-if="Rebook">{{ Rebook.from_airport_name }}</span> to <span v-if="Rebook">{{ Rebook.to_airport_name }}</span
            >, later today at <span v-if="Rebook">{{ moment(Rebook.date).format('HH:mm') }}</span
            >. As you have a waiting time we would like to offer you some refreshments.
          </p>
          <p>
            We would like to invite you to use below issued credit card with an amount of {{ airline.currency_code }} 5, which can
            be used to pay for some refreshments in one of the food and beverage outlets at the airport.
          </p>
        </div>
      </div>
      <div class="container">
        <div class="block-item">
          <div class="container">
            <h2 class="title sb_mobile sb_refreshment" style="font-size: 16pt; padding-left: 45pt; width: 100%; margin: 0">
              Refreshment {{ FlyToDay.currency }} {{ FlyToDay.price_per_person }}
            </h2>
          </div>
        </div>
        <div class="container">
          <div class="block_div">
            <div class="content-section-wrap">
              <div class="description-wrap">
                <p>We have issued a {{ FlyToDay.currency }} {{ FlyToDay.price_per_person }} creditcard for your convenience</p>
                <p>This creditcard will be valid until.</p>
                <p>
                  Date <span v-if="Rebook">{{ moment(Rebook.date).format('DD-MM-YYYY') }}</span> time
                  <span v-if="Rebook">{{ moment(Rebook.date).format('HH:mm') }}</span> and it can be used at the food and beverage
                  outlets at the airport.
                </p>
              </div>
              <CreditCard></CreditCard>
            </div>
          </div>
        </div>
      </div>
      <div class="block-item">
        <div class="container">
          <router-link
            style="display: block; padding: 10pt 0; text-transform: uppercase"
            :to="{ name: 'VirtualCreditCardDetail', query: { secret: secret } }"
          >
            <div>
              <AboutCreditCard></AboutCreditCard>
            </div>
          </router-link>
        </div>
      </div>
      <ButtonDownloadVoucher :name-voucher="nameVoucher" :can-download="canDownload"></ButtonDownloadVoucher>
    </div>
  </section>
</template>

<script>
import CreditCard from '@/components/CreditCard/index'
import AboutCreditCard from '@/components/AboutCreditCard/index'
import ButtonDownloadVoucher from '@/components/ButtonDownloadVoucher/index'
import Title from '@/components/Title/index'
import { replaceStr } from '@/utils/helper'
import { mapGetters } from 'vuex'

export default {
  name: 'FlyToDay',
  components: { CreditCard, AboutCreditCard, ButtonDownloadVoucher, Title },
  props: {
    secret: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nameVoucher: 'Refreshment',
      canDownload: false
    }
  },
  computed: {
    ...mapGetters({
      FlyToDay: 'FlyToDay/FlyToDay',
      Rebook: 'FlightNextDay/Rebook'
    })
  },
  watch: {
    FlyToDay: function (newVal) {
      this.canDownload = newVal.currency != '' ? true : false
    }
  },
  mounted() {
    this.$store.dispatch('FlyToDay/getFlyToDay')
    this.$store.dispatch('FlightNextDay/getRebook')
  },
  methods: {
    replaceStr
  }
}
</script>
